<template>
  <div>
    <!-- リスキリング補助制度：通常セット -->
    <div
      v-if="showEntryReskillingSet"
      class="flex flex-col items-baseline border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8"
    >
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_reskilling_set"
      >
        リスキリング補助制度
        <TeCommonBadgeRequired class="ml-2" />
      </label>
      <div class="basis-full md:basis-8/12">
        <div
          id="entry_reskilling_ai_set"
          class="mb-2 flex gap-x-4"
          @change="changeEntryReskillingSetSelected(entryReskillingSetSelected)"
        >
          <div
            v-for="(option, index) in entryReskillingOptions"
            :key="index"
            class="form-control"
          >
            <label class="cursor-pointer">
              <input
                v-model="entryReskillingSetSelected"
                type="radio"
                :value="option.value"
                name="entry-reskilling-set"
                required
                class="radio"
              >
              <span class="ml-2">{{ option.text }}</span>
            </label>
          </div>
        </div>
        <span
          v-if="errors.reskilling && errors.reskilling.length !== 0"
          class="te-invalid-feedback inline-block"
        >
          {{ errors.reskilling.join(", ") }}
        </span>
        <!-- リスキリング補助制度を選択した場合のアラート -->
        <div v-if="entryReskillingSetSelected === '0'">
          <p class="co-display-13 mb-0  mt-2">
            ※ 利用する場合は、下記の点に承諾しているものとみなします。
          </p>
          <ul class="co-display-13 mb-0 list-disc  pl-6">
            <li>
              <a
                href="/benefits/reskilling#eligible"
                target="_blank"
              >
                対象条件
              </a>
              や
              <a
                href="/benefits/reskilling#condition"
                target="_blank"
              >
                注意事項
              </a>
              を理解して申し込みを行う
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import TeCommonBadgeRequired from '~/components/Te/TeCommon/Badge/TeCommonBadgeRequired/TeCommonBadgeRequired.vue'

interface TextValue {
  value: string
  text: string
}

interface Data {
  entryReskillingSetSelected: string
  entryReskillingOptions: TextValue[]
  entryStudentSelected: string
}

interface Methods {
  changeEntryReskillingSetSelected: (selected: string) => void
}

interface Props {
  packScreenName: string | null
  showEntryReskillingSet: boolean
  showIsProBenefitSystem: boolean
  errors: any
}

const options = {
  props: {
    packScreenName: {
      type: String,
      default: null,
    },
    showEntryReskillingSet: {
      type: Boolean,
      default: false,
    },
    showIsProBenefitSystem: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: [
    'changeEntryReskillingSetSelected',
  ],
  data() {
    return {
      entryStudentSelected: '0',
      // リスキリング補助制度：通常コース
      entryReskillingSetSelected: '', // ラジオボタンの選択初期状態
      entryReskillingOptions: [
        { value: '0', text: '利用する' },
        { value: '1', text: '利用しない' },
      ],
    }
  },
  methods: {
    changeEntryReskillingSetSelected(selected: string) {
      this.$emit('changeEntryReskillingSetSelected', selected)
    },
  },
  components: {
    TeCommonBadgeRequired,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-invalid-feedback {
  width: 100%;
  margin-top: .25rem;
  font-size: .875em;
  color: #dc3545;
}
</style>
